<template>
  <div class="card shadow-sm card-terra h-100 position-relative">
    <!-- CABECERA -->
    <div class="card-header bg-biomasa text-white d-flex justify-content-between align-items-center">
      <div>
        <font-awesome-icon icon="leaf" class="me-2" />
        <strong>{{ biomasa.codigo }}</strong> - {{ biomasa.tipo_biomasa || 'Sin tipo' }}
      </div>
      <div class="dropdown text-end">
        <button class="btn btn-sm btn-light text-dark" type="button" data-bs-toggle="dropdown">
          <font-awesome-icon icon="ellipsis-v" />
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li><a class="dropdown-item" href="#" @click.prevent="verArbol = true">Ver Trazabilidad</a></li>
        </ul>
      </div>
    </div>

    <!-- CUERPO -->
    <div class="card-body">

      <div class="badge bg-success mb-2">Con materia prima asociada</div>

      <!-- Código biomasa -->
      <div class="badge badge-biomasa-verde mb-2 d-inline-flex align-items-center gap-2">
        {{ biomasa.codigo }}
        <button class="btn btn-sm btn-copy p-0" @click="copiarCodigoBiomasa">
          <font-awesome-icon :icon="['fas', 'copy']" />
        </button>
      </div>

      <!-- Materia prima asociada -->
      <div v-if="biomasa.materia_prima" class="mt-2 small">
        <strong>Materia Prima:</strong>
        <span class="badge badge-biomasa d-inline-flex align-items-center gap-2">
          {{ biomasa.materia_prima.codigo }}
          <button class="btn btn-sm btn-copy p-0" @click="copiarCodigoMateriaPrima">
            <font-awesome-icon :icon="['fas', 'copy']" />
          </button>
        </span>
      </div>

      <p class="mb-1"><strong>Proyecto:</strong> {{ biomasa.proyecto?.nombre || '—' }}</p>
      <p class="mb-1"><strong>Lote:</strong> {{ biomasa.lote?.nombre || '—' }}</p>
      <p class="mb-1"><strong>Plantas:</strong> {{ biomasa.planta_biomasa.length }}</p>

      <button class="btn btn-sm btn-link p-0 mt-2" @click="mostrarDetalles = !mostrarDetalles">
        {{ mostrarDetalles ? 'Ocultar Detalles' : 'Ver Más' }}
      </button>

      <div v-if="mostrarDetalles" class="mt-3 bg-light p-2 rounded small detalles">
        <p><strong>Fecha Cosecha:</strong> {{ formatDate(biomasa.fecha_cosecha) }}</p>
        <ul v-if="biomasa.planta_biomasa.length" class="small mb-2" style="max-height: 100px; overflow:auto;">
          <li v-for="pb in biomasa.planta_biomasa" :key="pb.id">{{ pb.planta.codigo }}</li>
        </ul>
        <p><strong>Observaciones:</strong> {{ biomasa.observaciones || '—' }}</p>
      </div>
    </div>

    <!-- MODAL TRAZABILIDAD -->
    <div v-if="verArbol" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Trazabilidad - {{ biomasa.codigo }}</h5>
            <button type="button" class="btn-close" @click="verArbol = false"></button>
          </div>
          <div class="modal-body p-0">
            <TrazabilidadBuscador :codigo-inicial="biomasa.codigo" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="verArbol = false">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Copiado flotante -->
    <div v-if="copiado" class="copiado-flotante">
      📋 Copiado al portapapeles
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import TrazabilidadBuscador from '@/components/Trazabilidad/TrazabilidadBuscador.vue';

export default {
  name: 'BiomasaCardConMateria',
  components: { FontAwesomeIcon, TrazabilidadBuscador },
  props: ['biomasa'],
  data() {
    return {
      mostrarDetalles: false,
      copiado: false,
      verArbol: false
    };
  },
  methods: {
    formatDate(d) {
      return d ? new Date(d).toLocaleDateString() : '—';
    },
    copiarCodigoBiomasa() {
      navigator.clipboard.writeText(this.biomasa.codigo)
        .then(() => {
          this.copiado = true;
          setTimeout(() => {
            this.copiado = false;
          }, 2000);
        });
    },
    copiarCodigoMateriaPrima() {
      if (this.biomasa.materia_prima) {
        navigator.clipboard.writeText(this.biomasa.materia_prima.codigo)
          .then(() => {
            this.copiado = true;
            setTimeout(() => {
              this.copiado = false;
            }, 2000);
          });
      }
    }
  }
};
</script>

<style scoped>
.card-title {
  color: #a84e1a;
  font-weight: 600;
}

.detalles {
  background-color: #fafafa;
}

.badge {
  font-size: 0.8rem;
  padding: 5px 10px;
}

.badge-biomasa {
  background-color: #a84e1a;
  color: white;
  font-weight: 600;
}

.badge-biomasa-verde {
  background-color: #28a745;
  color: white;
  font-weight: 600;
}

.btn-copy {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}

.btn-copy:hover {
  color: #ffc107;
}

.copiado-flotante {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: #333;
  color: white;
  padding: 8px 15px;
  border-radius: 4px;
  font-size: 0.8rem;
  opacity: 0.9;
  z-index: 10;
}

.bg-biomasa {
  background-color: #28a745 !important;
}
</style>
